document.addEventListener('DOMContentLoaded', () => {
    /**
     * Using a timeout here because we need to wait for the global `bronson` variable.
     * You just have to import the script after the main `bronson.min.js` and can
     * safely omit the `setTimeout` used here.
     */
    const CONSENT_STORAGE_ID = 'vwfs-video-content-accepted';
    setTimeout(function () {
        document.querySelectorAll('.js-video.js-video-consent-accept').forEach(function (element) {
            const video = element;
            const consentCallout = element.parentElement.querySelector('.js-video-consent');
            const consentButton = consentCallout.querySelector('.js-video-consent-trigger');

            const cookieControl = VWFSUtils.getCookie('CookieControl');
            const marketingAccepted = !!cookieControl && JSON.parse(cookieControl).optionalCookies.marketing === "accepted";
            const videoAccepted = localStorage.getItem(CONSENT_STORAGE_ID);

            /**
             * This function initializes all video players on the page.
             * Iterates over all elements with the class "js-video" to
             * get their respective video component and call the `init` method.
             */
            const initAllVideos = () => {
                document.querySelectorAll('.js-video.js-video-consent-accept').forEach(el => {
                    el.parentElement.querySelector('.js-video-consent')?.setAttribute('hidden', '');
                    el.setAttribute('src',el.getAttribute('data-src'));
                    el.removeAttribute('hidden');
                });
            };

            /**
             * If the user already set the preference to show videos,
             * hide the callout and initiate the video players and cleanup
             * any EventListeners.
             */
            if (marketingAccepted || videoAccepted === "true") {
                initAllVideos();
            } else {
                /**
                 * Attach an EventListener to the callout button.
                 */
                video.setAttribute("hidden", "");
                consentButton?.addEventListener('click', () => {
                    initAllVideos()

                    // store cookie consent flag in localStorage to remember the user choice
                    localStorage.setItem(CONSENT_STORAGE_ID, "true");                });
                consentCallout?.removeAttribute('hidden');
            }
        });
    }, 1000); /* Remove the setTimeout. */
});
